module.exports = __webpack_public_path__ + "img/IMAGE 4.ace7fc62.png";